var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrInputBox',{attrs:{"label":_vm.label,"active":_vm.active},on:{"click":_vm.toggleActive},scopedSlots:_vm._u([{key:"after",fn:function(){return [_c('VIcon',[_vm._v(_vm._s(_vm.activeIndicatorIcon))])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }